<script lang="ts">
    import { persons } from "../../../store"
    import MedialibImage from "../../MedialibImage.svelte"
    import Icon from "../../Icon.svelte"
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()
    const arrowRight =
        "M26.824 25L23.292 28.532C23.1053 28.7187 23.0187 28.9413 23.032 29.2C23.044 29.4587 23.144 29.682 23.332 29.87C23.5187 30.0567 23.75 30.15 24.026 30.15C24.302 30.15 24.5287 30.0567 24.706 29.87L29.446 25.13C29.77 24.8073 29.932 24.4307 29.932 24C29.932 23.5693 29.77 23.1927 29.446 22.87L24.67 18.092C24.4833 17.9053 24.26 17.812 24 17.812C23.74 17.812 23.5173 17.9053 23.332 18.092C23.1467 18.2787 23.0527 18.5107 23.05 18.788C23.0473 19.0653 23.1407 19.292 23.33 19.468L26.824 23H18C17.716 23 17.4787 23.096 17.288 23.288C17.0973 23.48 17.0013 23.718 17 24.002C16.9987 24.286 17.0947 24.5233 17.288 24.714C17.4813 24.9047 17.7187 25 18 25H26.824ZM24.006 42C21.518 42 19.178 41.528 16.986 40.584C14.7953 39.6387 12.8893 38.356 11.268 36.736C9.64667 35.116 8.36333 33.212 7.418 31.024C6.47267 28.836 6 26.4967 6 24.006C6 21.5153 6.47267 19.1753 7.418 16.986C8.362 14.7953 9.64267 12.8893 11.26 11.268C12.8773 9.64667 14.782 8.36333 16.974 7.418C19.166 6.47267 21.506 6 23.994 6C26.482 6 28.822 6.47267 31.014 7.418C33.2047 8.362 35.1107 9.64333 36.732 11.262C38.3533 12.8807 39.6367 14.7853 40.582 16.976C41.5273 19.1667 42 21.506 42 23.994C42 26.482 41.528 28.822 40.584 31.014C39.64 33.206 38.3573 35.112 36.736 36.732C35.1147 38.352 33.2107 39.6353 31.024 40.582C28.8373 41.5287 26.498 42.0013 24.006 42ZM24 40C28.4667 40 32.25 38.45 35.35 35.35C38.45 32.25 40 28.4667 40 24C40 19.5333 38.45 15.75 35.35 12.65C32.25 9.55 28.4667 8 24 8C19.5333 8 15.75 9.55 12.65 12.65C9.55 15.75 8 19.5333 8 24C8 28.4667 9.55 32.25 12.65 35.35C15.75 38.45 19.5333 40 24 40Z"
    const arrowLeft =
        "M21.178 25H30C30.284 25 30.5213 24.904 30.712 24.712C30.9027 24.52 30.9987 24.282 31 23.998C31.0013 23.714 30.9053 23.4767 30.712 23.286C30.5187 23.0953 30.2813 23 30 23H21.178L24.708 19.468C24.8947 19.2907 24.988 19.064 24.988 18.788C24.988 18.512 24.8947 18.28 24.708 18.092C24.5213 17.904 24.29 17.8107 24.014 17.812C23.7367 17.812 23.5093 17.9053 23.332 18.092L18.554 22.87C18.2313 23.1927 18.07 23.5693 18.07 24C18.07 24.4307 18.2313 24.808 18.554 25.132L23.332 29.908C23.5187 30.0947 23.748 30.1813 24.02 30.168C24.292 30.156 24.5213 30.056 24.708 29.868C24.8947 29.68 24.988 29.4487 24.988 29.174C24.988 28.8993 24.8947 28.6727 24.708 28.494L21.178 25ZM24.006 42C21.518 42 19.178 41.528 16.986 40.584C14.7953 39.6387 12.8893 38.356 11.268 36.736C9.64667 35.116 8.36333 33.212 7.418 31.024C6.47267 28.836 6 26.4967 6 24.006C6 21.5153 6.47267 19.1753 7.418 16.986C8.362 14.7953 9.64267 12.8893 11.26 11.268C12.8773 9.64667 14.782 8.36333 16.974 7.418C19.166 6.47267 21.506 6 23.994 6C26.482 6 28.822 6.47267 31.014 7.418C33.2047 8.362 35.1107 9.64333 36.732 11.262C38.3533 12.8807 39.6367 14.7853 40.582 16.976C41.5273 19.1667 42 21.506 42 23.994C42 26.482 41.528 28.822 40.584 31.014C39.64 33.206 38.3573 35.112 36.736 36.732C35.1147 38.352 33.2107 39.6353 31.024 40.582C28.8373 41.5287 26.498 42.0013 24.006 42ZM24 40C28.4667 40 32.25 38.45 35.35 35.35C38.45 32.25 40 28.4667 40 24C40 19.5333 38.45 15.75 35.35 12.65C32.25 9.55 28.4667 8 24 8C19.5333 8 15.75 9.55 12.65 12.65C9.55 15.75 8 19.5333 8 24C8 28.4667 9.55 32.25 12.65 35.35C15.75 38.45 19.5333 40 24 40Z"
    const chevronRight =
        "M35.4453 32L23.1786 19.7333L25.0666 17.8453L39.2213 32L25.0666 46.1547L23.1786 44.2667L35.4453 32Z"
    export let slide: HomePageTeaserSlide
</script>

<div class="slide">
    <div class="upper">
        <div class="image">
            {#if slide.person}
                <MedialibImage id="{$persons[slide.person]?.detailedImage}" />
            {:else}
                <MedialibImage id="{slide.image}" />
            {/if}
            <div class="splide-progress">
                <div class="splide-progress-bar"></div>
            </div>
        </div>
        <div class="background-image">
            <MedialibImage id="{slide.imageBackground}" />
        </div>
        {#if slide?.text}
            <div class="text">
                {slide.text}
            </div>
        {/if}
        <div class="splide__arrows">
            <button
                class="splide__arrow splide__arrow--prev btn transparent"
                on:click="{() => {
                    dispatch('prev')
                }}"
            >
                <Icon path="{arrowLeft}" size="48px" viewBox="0 0 48 48" />
            </button>
            <button
                class="splide__arrow splide__arrow--next btn transparent"
                on:click="{() => {
                    dispatch('next')
                }}"
            >
                <Icon path="{arrowRight}" size="48px" viewBox="0 0 48 48" />
            </button>
        </div>
    </div>
    {#if slide.person}
        <div class="lower">
            <Icon path="{chevronRight}" color="#59676F" size="64px" viewBox="0 0 64 64" />
            <div>
                <h3 class="name">
                    {#each $persons[slide.person]?.titles || [] as title}{title}&nbsp;{/each}{$persons[slide.person]
                        ?.name}
                </h3>
                <ul class="specialties">
                    {#each $persons[slide.person]?.specialties || [] as specialty}
                        <li>{specialty}</li>
                    {/each}
                </ul>
            </div>
        </div>{/if}
</div>

<style lang="less">
    @import "../../../../css/variables.less";
    .slide:global {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .upper {
            position: relative;
            .image {
                position: relative;
                left: 0px;
                margin-right: var(--default-gap);
                padding-right: calc(64px - var(--default-gap));
                border-radius: 6px 6px 48px 6px;
                overflow: hidden;
            }
            .background-image {
                position: absolute;
                bottom: 0px;
                left: 0px;
                right: var(--default-gap);
                height: 100%;
                z-index: -1;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;

                overflow-x: hidden;
                picture {
                    width: 100%;
                }
                img {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                    border-radius: 6px 6px 48px 6px;
                }
            }
            .splide__arrows {
                position: absolute !important;
                display: flex !important;
                height: 48px;
                width: fit-content;
                gap: 10px;
                bottom: 24px;
                right: 88px;

                .splide__arrow {
                    width: 48px;
                    height: 48px;
                    margin: 0px !important;
                    padding: 0px !important;
                    position: relative !important;
                    background: transparent;
                    transform: none !important;
                    top: initial !important;
                    left: initial !important;
                    right: initial !important;
                    bottom: initial !important;
                    svg {
                        height: 100% !important;
                        width: 100% !important;
                        margin: 0px !important;
                        transform: none !important;
                        color: white;
                        path {
                            height: 100%;
                            width: 100%;
                        }
                    }
                }
                @media @mobile {
                    display: none !important;
                }
            }
            .splide-progress {
                height: 4px;
                width: 100%;
                position: relative;
                z-index: 1000;
                margin-top: -4px;
                .splide-progress-bar {
                    height: 100%;
                    background: var(--orange-100);
                    width: 0px;
                }
            }
            .text {
                border-radius: 48px 2px 2px 2px;
                background: var(--orange-100);
                display: flex;
                padding: calc(var(--default-gap) / 2) var(--default-gap);
                position: absolute;
                font-style: italic;
                bottom: 100px;
                left: 312px;
                right: 0px;
                box-shadow: var(--dropshadow-box-shadow);
                color: white;
                font-size: 1.6rem;
                line-height: normal;
                font-weight: 400;
                @media @mobile {
                    position: relative;
                    bottom: initial;
                    left: initial;
                    border-radius: 2px 2px 48px 2px;
                }
            }
        }
        .lower {
            display: flex;
            margin-left: 64px;

            svg {
                width: 64px;
                padding: 6px 0px;
                padding-top: 14px;
            }
            div {
                padding-top: 28px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                gap: 18px;
                h3 {
                    margin: 0px;
                }
                ul {
                    font-size: 1.2rem;
                }
            }
            @media @mobile {
                margin-left: 0px;
            }
        }
    }
</style>
